import React from 'react'

import { Suspense } from '~/components/elements/Suspense'
import { useLogEventOnMount } from '~/hooks/useLogEventOnMount'

import { DocumentReportEdit } from './components/DocumentReportEdit'
import { useMainQuery } from './hooks/useMainQuery'

export const DocumentReportEditPage = () => {
  const { isLoading } = useMainQuery()

  useLogEventOnMount('Access to each document')

  return (
    <Suspense loading={isLoading}>
      <DocumentReportEdit />
    </Suspense>
  )
}
